module.exports = __webpack_public_path__ + "img/weixin.5b7534e4.png";